export interface IPage<T> {
  content: T[];
  totalElements: number;
  last: boolean;
  totalPages: number;
  number: number;
  size: number;
  scrollId?: string;
}

export const emptyPage: IPage<any> = {
  content: [],
  totalElements: 0,
  totalPages: 0,
  number: 1,
  size: 10,
  last: true,
};
